<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title fs-2">{{ alertSubject }}</h2>
            <button v-if="isDismiss" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div id="alert-modal-body" class="modal-body" v-html="alertContent"></div>
          <div class="modal-footer">
            <input type="hidden" id="is-hidden" v-model="isHidden">
            <button type="button" id="ok-btn" class="btn btn-primary" data-bs-dismiss="modal" >
              لا 
            </button>
            <button type="button" id="ok-btn" class="btn btn-primary" data-bs-dismiss="modal" @click="$parent[confirmModalFnc](submitParam)">
              نعم 
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import router from '@/router';
  
  export default {
    name: "AlertModal",
    props: {
      
        modalId: {
            default: "staticGeneralModal",
            type: String
        },
      alertContent: {
        default: "هل أنت متأكد من الإجراء ؟",
        type: String
      },
      alertSubject: {
        default: "تنبيه",
        type: String
      },
      backdrop: {
        default: "static",
        type: String
      },
      isDismiss: {
        default: true,
        type: Boolean
      },
      confirmModalFnc: {
          default: "confirmModalFnc",
          type: String
      },
      submitParam: {
          default: null,
          type: String
      },
    },
    data() {
      return {
        isHidden: 1,
        enableTimer: this.timeToEnable,
      };
    },
  }
  </script>